<section class="voice-offering-type">
  <div class="title">Telefonnummer</div>
  <div class="voice-number-options">
    <app-ice-select-box
      label="Nytt eller portere inn"
      radioTestId="is-subscription-upgrade-false-input"
      type="radio"
      [control]="form.get(EquipmentFormControls.IsSubscriptionUpgrade)"
      [disabled]="isBelowTheLineOffering"
      [matTooltip]="isBelowTheLineOffering ? 'Abonnementet kan kun fornyes på eksisterende nummer' : ''"
      [value]="false"
    />
    <app-ice-select-box
      label="Behold eksisterende ice-nummer"
      radioTestId="is-subscription-upgrade-true-input"
      type="radio"
      [control]="form.get(EquipmentFormControls.IsSubscriptionUpgrade)"
      [disabled]="!voiceProductsAvailableForUpgrade?.length"
      [matTooltip]="!voiceProductsAvailableForUpgrade?.length ? 'Ingen ledige/tilgjengelige nummer' : ''"
      [value]="true"
    >
      @if (form.get(EquipmentFormControls.IsSubscriptionUpgrade).value) {
        <div class="existing-offering-container">
          @if (form.get(EquipmentFormControls.IsSubscriptionUpgrade).value) {
            <mat-radio-group [formControl]="$any(form).get(EquipmentFormControls.SubscriptionIdToUpgrade)">
              @for (voiceProduct of voiceProductsAvailableForUpgrade; track voiceProduct.id) {
                <app-existing-offering-upgrade
                  [equipmentPaymentType]="equipmentPaymentType"
                  [existingProductsAvailableForEquipmentUpgrade]="existingProductsAvailableForEquipmentUpgrade"
                  [newOfferingId]="newOfferingId"
                  [subscriptionToUpgrade]="subscriptionToUpgrade"
                  [voiceProduct]="voiceProduct"
                  (resetSubscriptionIdToUpgrade)="onResetSubscriptionIdToUpgrade()"
                />
              }
            </mat-radio-group>
          }
        </div>
      }
    </app-ice-select-box>
  </div>
</section>
